import { memo } from 'react'

const ArtifactIcon: React.FC = memo(() => (
  <svg
    width={23}
    height={24}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54464 15.0586L2.06595 17.9307C2.00385 18.3033 1.9728 18.4896 2.03058 18.6243C2.08115 18.7422 2.1751 18.8362 2.293 18.8867C2.42771 18.9445 2.614 18.9135 2.98658 18.8514L5.85875 18.3727C6.60995 18.2475 6.98552 18.1849 7.33602 18.0565C7.64702 17.9425 7.94262 17.7904 8.21612 17.6035C8.52432 17.393 8.79362 17.1237 9.33212 16.5852L16.8818 9.03553C18.2625 7.65482 18.2625 5.41624 16.8818 4.03553C15.5011 2.65482 13.2625 2.65482 11.8818 4.03553L4.33208 11.5852C3.79357 12.1237 3.52432 12.393 3.31379 12.7012C3.12695 12.9747 2.97481 13.2703 2.86085 13.5813C2.73244 13.9318 2.66984 14.3074 2.54464 15.0586Z"
      stroke="#ffffff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

export { ArtifactIcon }
